import {animated} from 'react-spring';

import styled, {css} from 'styled-components';

import {Button as BaseButton} from '@edna/components';
import {mixins} from '@edna/components/styles';
import BaseCloseIcon from '@edna/icons/close.svg';

import {Badge as BaseBadge} from 'src/components';
import {Text} from 'src/components/primitives';

export const Badge = styled(BaseBadge).attrs({color: 'GREY'})`
  ${mixins.f2};
  ${mixins.stack({direction: 'ROW', align: 'center', size: '1'})};
  border-width: 1px;
  font-weight: 500;
  color: ${({theme}) => theme.branding.content.secondary};
`;

export enum ENewsBorderColor {
  YELLOW = 'YELLOW',
  GREY = 'GREY',
  GREEN = 'GREEN',
}
export type TNewsBorderColor = keyof typeof ENewsBorderColor;

const getNewsBorderColor = ({color, theme}: TTheme & {color: TNewsBorderColor}) => {
  switch (color) {
    case 'YELLOW':
      return css`
        border-color: ${theme.branding.colors.warning};
      `;
    case 'GREY':
      return css`
        border-color: ${theme.palette.grey200};
      `;
    case 'GREEN':
    default:
      return css`
        border-color: ${theme.branding.colors.accentA};
      `;
  }
};

export const News = styled.div<{noHighlight?: boolean; color?: TNewsBorderColor}>`
  ${mixins.f2};
  width: 100%;
  box-shadow: none;
  white-space: break-spaces;
  ${({theme, noHighlight}) => css`
    padding: ${noHighlight ? theme.spacing.s4 : theme.spacing.s6};
    border: ${noHighlight ? 1 : 2}px solid transparent;
    border-radius: ${theme.borderRadius.br4};
  `};
  ${getNewsBorderColor}
`;

export const Content = styled(Text)`
  flex-grow: 1;
`;

export const NewsDate = styled.span`
  ${mixins.f5};
  width: inherit;
  color: ${({theme}) => theme.palette.green500};
`;

export const CloseIcon = styled(BaseCloseIcon)`
  ${mixins.wh('24px')}
  flex-shrink: 0;
  cursor: pointer;
  color: ${({theme}) => theme.branding.content.tertiary};
`;

export const Button = styled(BaseButton)`
  margin-top: ${({theme}) => theme.spacing.s5};
  margin-right: auto;
`;

export const AnimatedDiv = styled(animated.div)`
  width: 100%;
`;
